export enum MODEL_PORTFOLIO_TYPES {
  ALL_MODELS = 'allModels',
  MY_MODELS = 'myModels',
  ENTERPRISE_MODELS = 'enterpriseModels',
}
